// extracted by mini-css-extract-plugin
export var backdrop = "_g5-1";
export var dragging = "_g5-4";
export var handle = "_g5-6";
export var handleHit = "_g5-5";
export var listEnd = "_g5-8";
export var modalRoot = "_g5-0";
export var sectionHeader = "_g5-a";
export var sheet = "_g5-3";
export var sheetHost = "_g5-2";
export var shortcutColumns = "_g5-7";
export var shortcutSection = "_g5-9";